/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SvgEditorComponent as Éµa} from './src/app/svg/svg-editor/svg-editor.component';